import { Component, Input } from '@angular/core';
import { DataStorageService } from '../../../dataservices/data-storage.service';
import { FunCollectionService } from '../../../common/common-functions/fun-collection.service';
@Component({
  selector: 'app-detail-suggestion-card',
  templateUrl: './detail-suggestion-card.component.html',
  styleUrls: ['./detail-suggestion-card.component.scss']
})
export class DetailSuggestionCardComponent {
  @Input() callingfrom;
  @Input() sugglistObj;

  constructor(public fcs: FunCollectionService, private dss: DataStorageService) { }

  getFeeddetail(): void {
    if (this.sugglistObj.target.type == 'feed' && this.callingfrom == 'journaldetail') {
      const feedDetailObj = {
        is_show: true,
        feed_id: this.sugglistObj.target.id,
        mediaIdx: 0
      };
      this.dss.showFeedDetailInModal.next(feedDetailObj);
    } else if (this.sugglistObj.target.type != 'feed') {
      const feedDetailObj = {
        is_show: false,
        feed_id: 0,
        mediaIdx: 0
      };
      this.dss.showFeedDetailInModal.next(feedDetailObj);
      // console.log(this.sugglistObj.target)
      setTimeout(() => {
        this.fcs.redirectOnSection(this.sugglistObj.target.type, this.sugglistObj.target.id);
      }, 200);
    } else {
      this.dss.feedDetailChanged.next(this.sugglistObj.target);
    }

  }

}
